module.exports = __webpack_public_path__ + "img/private-restaurant.2f75a77f.jpg";